import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../../Api/api';

export const userAvatarUrl = (profile) => {
  if (!profile) return null;
  if (profile.startsWith('http')) return profile;
  const p = String(profile).replace(/^\/+/, '');
  return `${BASE_URL}/${p.startsWith('uploads/') ? p : `uploads/${p}`}`;
};

const UserAvatar = ({ user, size = 40, onClick }) => {
  const [imgFailed, setImgFailed] = useState(false);
  const src = userAvatarUrl(user?.profile);
  const initial = String(user?.user_name || '?').trim().charAt(0).toUpperCase();
  const showImg = Boolean(src) && !imgFailed;
  const clickable = Boolean(onClick) && showImg;

  useEffect(() => {
    setImgFailed(false);
  }, [user?.profile]);

  const handleClick = (e) => {
    if (!clickable) return;
    e.stopPropagation();
    onClick(e);
  };

  const handleKeyDown = (e) => {
    if (!clickable) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      e.stopPropagation();
      onClick(e);
    }
  };

  return (
    <div
      className={`admin-user-avatar${clickable ? ' admin-user-avatar--clickable' : ''}`}
      style={{ width: size, height: size, fontSize: size * 0.38 }}
      title={clickable ? `View ${user?.user_name || 'user'} photo` : user?.user_name}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
    >
      {showImg ? (
        <img src={src} alt="" onError={() => setImgFailed(true)} />
      ) : (
        <span className="admin-user-avatar__initial">{initial}</span>
      )}
    </div>
  );
};

export default UserAvatar;
